import {
  APPROVAL_PROFILE_360,
  APPROVAL_PROFILE_360_SUCCESS,
  APPROVAL_PROFILE_360_ERROR,
  APPROVAL_PROFILE_360_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApprovalProfile360 = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_PROFILE_360:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_PROFILE_360_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_PROFILE_360_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVAL_PROFILE_360_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApprovalProfile360;
